import cn from 'classnames';
import { TextSkeleton } from 'components/text-skeleton';
import { FC } from 'react';

interface IProductCardSkeletonProps {
  isSlider?: boolean;
}

/**
 * ProductCardSkeleton Component
 */
const ProductCardSkeleton: FC<IProductCardSkeletonProps> = ({ isSlider }) => (
  <div
    className={cn(
      isSlider ? 'h-[312px] flex-col items-start lg:h-[356px]' : 'items-center lg:h-[466px]',
      'bg-other-white flex h-[172px] gap-2 rounded-sm py-3 pr-3 pl-2 shadow-sm lg:flex-col lg:items-start'
    )}
  >
    <div
      className={cn(
        isSlider ? 'w-full' : 'w-2/5',
        'bg-grey-100 h-32 animate-pulse rounded-lg px-12 py-8 lg:h-46 lg:w-full'
      )}
    />
    <div
      className={cn(
        isSlider ? 'w-full' : 'w-3/5',
        'flex h-32 flex-col justify-between gap-2.5 lg:w-full'
      )}
    >
      <TextSkeleton />
      <div
        className={cn(
          isSlider ? 'h-3' : 'hidden h-4',
          'bg-grey-100 w-full shrink-0 animate-pulse rounded-2xl lg:block'
        )}
      />

      <div
        className={cn(
          isSlider ? 'h-3' : 'h-2.5',
          'bg-grey-100 w-4/5 shrink-0 rounded-2xl lg:hidden lg:h-4'
        )}
      />
      <div
        className={cn(
          isSlider ? 'h-3' : 'h-2.5',
          'bg-grey-100 w-2/3 shrink-0 rounded-2xl lg:hidden lg:h-4 lg:w-3/5'
        )}
      />

      <div className="flex w-1/4 shrink-0 gap-3 lg:w-1/4">
        <div className="bg-grey-100 h-2.5 w-full shrink-0 rounded-2xl lg:h-4" />
        <div className="bg-grey-100 h-2.5 w-full shrink-0 rounded-2xl lg:h-4" />
      </div>
    </div>
  </div>
);

export default ProductCardSkeleton;
